export const visit = (vm, at) => {
at({ "it": { "uiAddonTeams": { "teamSelectLabelOne": "1 team selezionato", "teamSelectLabelMany": "{{ count }} team selezionati", "selectTeams": "Seleziona team", "selectAll": "Seleziona tutti ({{ teamName }})" } } });
};